import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  AppBar,
  Toolbar,
  IconButton,
  Box,
  Grid,
} from '@material-ui/core';

import {
  Group as SubsIcon,
} from '@material-ui/icons';

import StarsIcon from '@material-ui/icons/Stars';
import StarIcon from '@material-ui/icons/Star';
import StarOutlineIcon from '@material-ui/icons/StarOutline';
import useStyles from './styles';

// components
import { Typography, Avatar } from '../Wrappers/Wrappers';
import EcalProfileLogo from '../../commons/images/brandImage/ecal_icon_purple_light.svg';

import ProfileMenu from './ProfileMenu';
import NotficationsMenu from './NotificationsMenu';
import MessageMenu from './MessageMenu';
import BackMenuButton from './BackMenuButton';
import { messages, notifications } from './mock';
import { useDashboardStore } from '../../store/models';
import useWhiteLabel from '../../store/models/styles/useWhiteLabel';


function getHeaderBackgroundColor (planName) {
  const defaultColor = '#010134';

  // Maps subscription plan → badge background color
  const planBackgrounds = {
    'free trial': defaultColor,
    free: defaultColor,
    basic: 'linear-gradient(90deg, #0078ff, #000082)',
    community: 'linear-gradient(90deg, #ff9e00, #ff4d00)',
    grow: 'linear-gradient(90deg, #ffdf10, #ff9e00)',
    professional: 'linear-gradient(90deg, #00d7ff, #00d456)',
    pro: 'linear-gradient(90deg, #00d7ff, #00d456)',
    enterprise: 'linear-gradient(90deg, #00d7ff, #0078ff)',
    'enterprise partners': 'linear-gradient(90deg, #00d7ff, #0078ff)',
  };
  return planBackgrounds[(planName || '').toLowerCase()] || defaultColor;
}

function Header (props) {
  const {
    userInfo,
    onSignOut,
    publisher,
    publisherLogo,
    subsRemaining,
    role,
    aws,
  } = props;
  const {
    whiteLabelSettings,
  } = useWhiteLabel();
  const dashboardStore = useDashboardStore();
  const [headerBackground, setHeaderBackground] = useState(getHeaderBackgroundColor());
  const classes = useStyles({ headerBackground });

  const [mailMenu, setMailMenu] = useState(null);
  const [notificationsMenu, setNotificationsMenu] = useState(null);
  const [profileMenu, setProfileMenu] = useState(null);
  const loadDashboardData = async () => {
    await dashboardStore.getTotalSubscribers();
  };
  useEffect(() => {
    loadDashboardData();
  }, []);

  useEffect(function () {
    if (whiteLabelSettings.labelName !== 'ecal') {
      setHeaderBackground(whiteLabelSettings.headerColor);
      return;
    }

    setHeaderBackground(getHeaderBackgroundColor(publisher?.planName));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [publisher?.planName]);

  function company () {
    if (!publisher) {
      return '';
    }

    if (publisher.company) {
      return publisher.company;
    }

    if (publisher.orgName) {
      return publisher.orgName;
    }

    if (publisher.name) {
      return publisher.name;
    }

    return publisher.firstName + ' ' + publisher.lastName;
  }
  return (
    <AppBar position="fixed" className={classes.appBar}>
      <Toolbar className={classes.toolbar}>
        <BackMenuButton />
        <Box
          display='flex'
          flexDirection='row'
          width='100%'
          justifyContent='space-between'>
          <Box display='flex'>
            <Box
              component={Grid}
              className={classes.mobileLogoContainer}
              item
              sx={{ display: { xs: 'block', sm: 'none' } }}
            >
              <img src={whiteLabelSettings?.logo} alt="logo" className={classes.mobileLogotypeImage} />
            </Box>
            <Box
              component={Grid}
              className={classes.logoContainer}
              item
              sx={{ display: { xs: 'none', sm: 'block' } }}
            >
              <img src={whiteLabelSettings?.logo} alt="logo" className={classes.logotypeImage} />
            </Box>
            <div className={classes.orgNameContainer}>
            <Typography variant="h6" weight="medium" className= {classNames([
                          classes.profileLabel,
                          classes.orgName,
                      ])}
            >
              { company() }
            </Typography>
          </div>
          </Box>
          <Box display='flex' flexDirection='row'>
          <Box
            display='flex'
            flexDirection='column'
            marginBottom='-18px'
            justifyContent='center'>
            <Box
              display='flex'
              justifyContent='center'
              alignItems='end'>
              <Box
              display='flex'
              width='24px'
              height='24px'justifyContent='center'>
                { publisher.planName === 'Enterprise' ? <StarsIcon fontSize='medium' /> : null}
                { publisher.planName === 'Expert' || publisher.planName === 'Pro' || publisher.planName === 'Professional' || publisher.planName === 'Grow' ? <StarIcon fontSize='medium' /> : null}
                { publisher.planName !== 'Enterprise' && publisher.planName !== 'Pro' && publisher.planName !== 'Professional' && publisher.planName !== 'Grow' && publisher.planName !== 'Expert' ? <StarOutlineIcon fontSize='medium' /> : null}
              </Box>
            </Box>
            <Typography variant={'caption'} className={classes.planSubText} >
              {publisher ? publisher.planName : ''}
            </Typography>
          </Box>
          <div className={classes.lineDividerHeader}></div>
          <Box
            display='flex'
            flexDirection='column'
            marginBottom='-18px'
            width='115'
            justifyContent='center'>
            <Box
              display='flex'
              justifyContent='center'
              alignItems='end'>
              <SubsIcon fontSize="medium" />&nbsp;
              <Typography variant={'body2'} className={classes.subsRemText}>
                {subsRemaining === 'infinity' ? <span>&#8734;</span> : subsRemaining}
            </Typography>
            </Box>
            <Typography variant={'caption'} className={classes.planSubText} >
              Subscriptions Rem.
            </Typography>
          </Box>
          <div className={classes.lineDividerHeader}></div>
          <IconButton
            aria-haspopup="true"
            color="inherit"
            className={classes.headerMenuButton}
            aria-controls="profile-menu"
            onClick={e => setProfileMenu(e.currentTarget)}
            disableRipple
            disableFocusRipple
          >
            <Avatar
              alt=""
              variant="square"
              className={classes.avatarImage}
              classes={{ root: classes.headerIcon }}>
                <img height={24} width={24} src={publisherLogo} alt="logo" className={classes.logotypeImage} />
            </Avatar>
          </IconButton>

          <div className={classes.userNameContainer}
        >
          <Typography variant={'body2'} className= {classNames([
                        classes.profileLabel,
                        classes.subsRemText,
                    ])}
          >
            { userInfo.firstName} { userInfo.lastName }
          </Typography>
        </div>
        </Box>
        </Box>
            <MessageMenu
                 open={Boolean(mailMenu)}
                 anchorEl={mailMenu}
                 onClose={() => setMailMenu(null)}
                 messages={messages}
            />

            <NotficationsMenu
              open={Boolean(notificationsMenu)}
              anchorEl={notificationsMenu}
              onClose={() => setNotificationsMenu(null)}
              onSelectNotification={() => setNotificationsMenu(null)}
              notifications={notifications}
            />

            <ProfileMenu
              open={Boolean(profileMenu)}
              anchorEl={profileMenu}
              onClose={() => setProfileMenu(null)}
              onSignOut={() => onSignOut()}
              userInfo={userInfo}
              role={role}
              aws={aws}
            />
      </Toolbar>
    </AppBar>
  );
}

Header.propTypes = {
  greetings: PropTypes.string,
  userInfo: PropTypes.object,
  publisher: PropTypes.object,
  onSignOut: PropTypes.func,
  publisherLogo: PropTypes.any,
  role: PropTypes.any,
  aws: PropTypes.object,
};

Header.defaultProps = {
  greetings: 'Hi',
  userInfo: {
    name: '',
  },
  publisher: {},
  onSignOut: () => {},
  publisherLogo: EcalProfileLogo,
  role: {},
  aws: {},
};

export default observer(Header);
